import React, { Children, useEffect, useState } from "react";
import { TopBanner } from "../top-banner";
import { TopMenu } from "../top-menu";
import { Footer } from "../footer";
import { Helmet } from "react-helmet";
import { toScrollSection } from "../../../utils";
import MobileMenu from "../top-menu/menu-mob";

interface Props {
  children: any;
  disableScrrol?: boolean;
}

export const Main: React.FC<Props> = ({ children, disableScrrol }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    toScrollSection("main");

    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <>
      <Helmet>
        <script src="/assets/js/main.js" type="text/javascript" />
      </Helmet>
      {isMobile ? <MobileMenu /> : <TopMenu />}
      <TopBanner />
      <div id={disableScrrol ? "" : "main"}>
        {Children.map(children, (child) => child)}
      </div>
      <Footer />
    </>
  );
};
